import { styled } from "@mui/material";

export const StyledDescription = styled('p')(() => ({
    padding: '0 32px',
    color: "rgb(21, 41, 53)",
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: "normal",
    letterSpacing: "0.15px",
    lineHeight: "24px"
}));
